import { render, staticRenderFns } from "./AttendanceTab.vue?vue&type=template&id=25ef54f6"
import script from "./AttendanceTab.vue?vue&type=script&lang=js"
export * from "./AttendanceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports